import { productImages } from './siteConfig';
import type { DetailRow, Faq, Feature, ProductImage, StoryStep } from '../types/content';

export const features: Feature[] = [
  {
    title: 'Laser facial technology',
    body: 'Professionally designed for home and medical office use.',
  },
  {
    title: 'Handheld controller',
    body: 'A compact controller with a clear display and simple buttons.',
  },
  {
    title: '“Hi Mask” voice command',
    body: 'Say “Hi Mask” and control the mask hands-free.',
  },
];

export const galleryImages: ProductImage[] = [
  productImages.white,
  productImages.voice,
  productImages.emitters,
];

export const storySteps: StoryStep[] = [
  {
    id: 'fit',
    title: 'Put it on',
    body: 'The soft, flexible mask rests over the face and is held in place by a head strap.',
    image: productImages.white,
  },
  {
    id: 'voice',
    title: 'Say “Hi Mask”',
    body: 'Wake the mask with a simple voice command and keep your hands free.',
    image: productImages.voice,
  },
  {
    id: 'controller',
    title: 'Or reach for the controller',
    body: 'Prefer buttons? The handheld controller pairs a small display with a simple layout.',
    image: productImages.controller,
  },
  {
    id: 'manual',
    title: 'Choose your setting',
    body: 'Use the included manual to explore the light settings and follow the operating guidance.',
    image: productImages.emitters,
  },
];

export const kitContents: string[] = [
  'AuraGlow Luxe mask in White',
  'Handheld controller',
  'USB charging cable',
  'User manual',
];

export const productDetails: DetailRow[] = [
  { label: 'Color', value: 'White' },
  { label: 'Technology', value: 'Laser + blue LED' },
  { label: 'Laser emitters', value: '164' },
  { label: 'Blue LEDs', value: '72' },
  { label: 'Wavelengths', value: '460, 665, 850 and 1064 nm' },
  { label: 'Shell', value: 'Silicone' },
  { label: 'Eye area', value: 'Wide, open eye opening' },
  { label: 'Fit', value: 'Head strap' },
  { label: 'Controls', value: '“Hi Mask” voice command and handheld controller' },
  { label: 'Charging', value: 'USB charging cable included' },
  { label: 'Battery capacity', value: '1,800 mAh' },
  { label: 'Guidance', value: 'User manual included' },
];

export const faqs: Faq[] = [
  {
    id: 'technology',
    question: 'What type of light technology does the mask use?',
    answer: 'AuraGlow Luxe combines 164 laser emitters with 72 blue LEDs across four wavelengths: 460, 665, 850 and 1064 nm. The included manual explains the light settings and how to use the mask.',
  },
  {
    id: 'light-colors',
    question: 'What do the different light colors mean?',
    answer: 'The mask combines visible blue light at 460 nm and red light at 665 nm with near-infrared light at 850 and 1064 nm. Near-infrared is invisible to the eye; the color treatments in the wavelength illustration help distinguish the settings.',
  },
  {
    id: 'wrinkles',
    question: 'How does light therapy relate to fine lines and wrinkles?',
    answer: 'Red and near-infrared light are studied in skincare for signs of aging, including the appearance of fine lines and wrinkles. Research on light therapy does not establish the same result for every device or person. Follow the product manual and discuss suitability with your dermatologist.',
  },
  {
    id: 'colors',
    question: 'Which colors are available?',
    answer: 'The AuraGlow Luxe mask launches in White.',
  },
  {
    id: 'voice',
    question: 'How does the voice command work?',
    answer: 'Say “Hi Mask” to get started. Refer to the included manual for setup and operating guidance.',
  },
  {
    id: 'controller',
    question: 'Can I use it without voice control?',
    answer: 'Yes. Every kit includes a handheld controller with a display and simple buttons.',
  },
  {
    id: 'sessions',
    question: 'How should I use it?',
    answer:
      'Please follow the user manual included in the box. If anything is unclear, our support team is happy to talk it through.',
  },
  {
    id: 'charging',
    question: 'How is it charged?',
    answer: 'With the USB charging cable included in the kit. Charging steps are covered in the manual.',
  },
  {
    id: 'who',
    question: 'Is it designed for men and women?',
    answer: 'AuraGlow Luxe is offered for men and women. Follow the product manual for suitability and use.',
  },
  {
    id: 'orders',
    question: 'Where can I find shipping and order details?',
    answer: 'Shipping is free. Orders usually ship in 1–2 days; this is the dispatch timeframe, not a delivery estimate. Tax is shown at checkout. For questions about your order, call our support team.',
  },
];

